import Rabbit from './components/Rabbit'
import Beetle from './components/Beetle'
import Lion from './components/Lion'

export default Rabbit

export { Beetle, Rabbit, Lion }



// WEBPACK FOOTER //
// ./src/lib/index.js